export default class NotistackVariants {
    static success = {variant: 'success'};
    static warning = {variant: 'warning'};
    static error = {variant: 'error'};
    static info = {variant: 'info'};
}